module.exports = __webpack_public_path__ + "static/img/video-ai.a9c3394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPhonePage/video-ai.png
// module id = 7GFd
// module chunks = 0